import Repository from "./Repository";

const resource = "/ExternalModule";

export default {
  get() {
    return Repository.get(`${resource}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
